export default __webpack_public_path__ + "static/open-book-alive-755df82ac8cbd4c72cb8b5aec695ce7c.jpg";